// returns the more legible of white / near-black text for a given badge color (WCAG-based)
//
// Expects a hex color (the badge color always comes from BrandOrCustomColor, which stores
// hex). Non-hex inputs (named / rgb()) parse to 0,0,0 → white text, a safe default.
//
// NOTE: with only two fixed text colors, some mid-tone badge colors may not reach
// the AA 4.5:1 ratio with either choice. We return the higher-contrast option
// (best effort); the badge color itself should be chosen with contrast in mind.
const DARK_TEXT = "#111111";
const LIGHT_TEXT = "#FFFFFF";

function relativeLuminance(hex: string): number {
  let h = hex.replace("#", "").trim();
  if (h.length === 3) h = h.split("").map((c) => c + c).join("");
  // Callers pass `parseInt(...) || 0`, so v is always a valid 0–255 number here.
  const toLin = (v: number) => {
    const c = v / 255;
    return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
  };
  const r = toLin(parseInt(h.slice(0, 2), 16) || 0);
  const g = toLin(parseInt(h.slice(2, 4), 16) || 0);
  const b = toLin(parseInt(h.slice(4, 6), 16) || 0);
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

function ratio(l1: number, l2: number): number {
  const [hi, lo] = l1 >= l2 ? [l1, l2] : [l2, l1];
  return (hi + 0.05) / (lo + 0.05);
}

export function contrastText(hex: string): "#FFFFFF" | "#111111" {
  const bg = relativeLuminance(hex);
  const darkRatio = ratio(relativeLuminance(DARK_TEXT), bg);
  const lightRatio = ratio(relativeLuminance(LIGHT_TEXT), bg);
  return darkRatio >= lightRatio ? DARK_TEXT : LIGHT_TEXT;
}
